import React from 'react';
import styles from './Step.module.less';

const Step5 = () => (
  <div className={styles.stepContainer}>
    <p>
      <strong>Export your list</strong> to print or share it anytime. Need help getting started? We
      have a template for you.
    </p>
    <video muted playsInline autoPlay preload="auto" loop>
      <source
        src="https://zola-web-assets.s3.us-east-1.amazonaws.com/web-wedding/guest-list-animations/Download.mp4"
        type="video/mp4"
      />
      Sorry, your browser doesn&apos;t support embedded videos.
    </video>
  </div>
);

export default Step5;



// WEBPACK FOOTER //
// ./src/pages/TourSteps/Step5.jsx